import React, { useEffect, useState } from "react";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import Icon from "../components/ui/Icon";
import Switch from "../components/ui/Switch";
import { InputField } from "../components/ui/Field";
import { maskKey } from "../utils/format";

export function SettingsPage({ data, onChange, notify, setCurrentPage }) {
  const [formState, setFormState] = useState(data);

  useEffect(() => {
      // console.log("Current URL:", window.location.pathname);
      setCurrentPage('/settings');
    }, [window.location]);


  useEffect(() => {
    setFormState(data);
  }, [data]);

  const updateAccount = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      account: {
        ...prev.account,
        [field]: value,
      },
    }));
  };

  const toggleNotification = (key) => {
    setFormState((prev) => ({
      ...prev,
      notifications: prev.notifications.map((item) =>
        item.key === key ? { ...item, enabled: !item.enabled } : item
      ),
    }));
  };

  const handleSave = () => {
    onChange?.(formState);
    notify?.({
      tone: "success",
      title: "Settings saved",
      description: "Your preferences have been updated.",
    });
  };

  const handleSecurityAction = (action) => {
    notify?.({
      tone: "info",
      title: action,
      description: "This action is simulated in the demo UI.",
    });
  };

  const handleCopyKey = (apiKey) => {
    notify?.({
      tone: "success",
      title: "API key copied",
      description: `${apiKey.label} has been copied to your clipboard.`,
    });
  };

  const handleDeleteAccount = () => {
    notify?.({
      tone: "danger",
      title: "Delete account",
      description: "This is a demo. No real data has been deleted.",
    });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">Manage your account and application settings</p>
        </div>
        <div className="page-actions">
          <Button variant="primary" iconLeft={<Icon name="save" size={16} />} onClick={handleSave}>
            Save Changes
          </Button>
        </div>
      </div>

      <div className="split-grid">
        <div className="panel-stack">
          <Card title="Account Settings">
            <div className="form-grid">
              <InputField
                label="Email Address"
                type="email"
                value={formState.account.email}
                onChange={(event) => updateAccount("email", event.target.value)}
              />
              <InputField
                label="Current Password"
                type="password"
                value={formState.account.currentPassword}
                onChange={(event) => updateAccount("currentPassword", event.target.value)}
              />
            </div>
            <div className="form-grid cols-2">
              <InputField
                label="New Password"
                type="password"
                value={formState.account.newPassword}
                onChange={(event) => updateAccount("newPassword", event.target.value)}
              />
              <InputField
                label="Confirm Password"
                type="password"
                value={formState.account.confirmPassword}
                onChange={(event) => updateAccount("confirmPassword", event.target.value)}
              />
            </div>
          </Card>

          <Card title="Notification Preferences">
            {formState.notifications.map((item) => (
              <div key={item.key} className="toggle-row">
                <div className="toggle-meta">
                  <div className="toggle-label">{item.label}</div>
                  <div className="toggle-description">{item.description}</div>
                </div>
                <Switch
                  label={item.label}
                  checked={item.enabled}
                  onChange={() => toggleNotification(item.key)}
                />
              </div>
            ))}
          </Card>

          <Card title="API Keys">
            {formState.apiKeys.map((apiKey) => (
              <div key={apiKey.id} className="api-key-row">
                <div>
                  <div className="field-label api-key-label">{apiKey.label}</div>
                  <div className="api-key-value">{maskKey(apiKey.value)}</div>
                </div>
                <Button variant="secondary" size="sm" onClick={() => handleCopyKey(apiKey)}>
                  Copy
                </Button>
              </div>
            ))}
          </Card>
        </div>

        <div className="panel-stack">
          <Card title="Account Information">
            <div className="info-list">
              <div className="info-item">
                <span className="info-label">Plan</span>
                <span className="info-value">{formState.accountInfo.plan}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Account Created</span>
                <span className="info-value">{formState.accountInfo.createdAt}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Last Login</span>
                <span className="info-value">{formState.accountInfo.lastLogin}</span>
              </div>
            </div>
          </Card>

          <Card title="Security" subtitle="Protect your account">
            <div className="helper-list">
              {formState.securityActions.map((action) => (
                <Button
                  key={action}
                  variant="secondary"
                  className="helper-action"
                  onClick={() => handleSecurityAction(action)}
                >
                  {action}
                </Button>
              ))}
            </div>
          </Card>

          <Card title="Danger Zone">
            <div className="danger-zone">
              <div className="danger-zone-title">Delete Account</div>
              <Button variant="danger" className="btn-block" onClick={handleDeleteAccount}>
                Delete Account
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
